<template>  
    <textarea max="max" :placeholder="placeholder" maxlength="maxlength" class="w3-input w3-border w3-bottom w3-bar TextBoxEditorDisplay" style="width:92%" v-model='fieldModelValue' /> 
</template>
<script>
export default {  
  props: ["value","max","maxlength","placeholder"],  
  computed: { 
    fieldModelValue: {
          get() {
            return this.value;
          },
          set(newValue) {
            this.$emit('input', newValue);
          }
    } 
  }
};
</script>
 
<style>
   .TextBoxEditorDisplay{
     height:100px; 
     padding:10px;          
     margin-right: 40px;     
     margin-bottom: 40px;
     background-color: white
   }
</style>



// WEBPACK FOOTER //
// src/components/shared/PageNotesEditor.vue